import { normalizeParsedPayload } from './textCase';

/** Merge parsed resume API payload into candidate form state. */
export function mergeParsedIntoCandidateForm(form, parsed) {
  const p = normalizeParsedPayload(parsed);
  return {
    ...form,
    name: p.name || form.name,
    email: p.email || form.email,
    phone: p.phone || form.phone,
    profileHeading: p.profileHeading || form.profileHeading,
    experience: p.experience ?? form.experience,
    currentSalary: p.currentSalary || form.currentSalary,
    expectedSalary: p.expectedSalary || form.expectedSalary,
    preferredWorkLocations: p.location
      ? [...new Set([...(form.preferredWorkLocations || []), p.location].filter(Boolean))]
      : form.preferredWorkLocations || [],
    location: p.location || form.location,
    availability: p.availability || form.availability,
    skills: [...new Set([...(form.skills || []), ...(p.skills || [])])],
    personal: {
      ...form.personal,
      ...(p.personal || {}),
      name: p.personal?.name || p.name || form.personal?.name,
      dob: p.personal?.dob || form.personal?.dob,
      gender: p.personal?.gender || form.personal?.gender || '',
      maritalStatus: p.personal?.maritalStatus || form.personal?.maritalStatus || '',
      address: p.personal?.address || form.personal?.address,
      city: p.personal?.city || form.personal?.city,
      state: p.personal?.state || form.personal?.state,
      zip: p.personal?.zip || form.personal?.zip,
      country: p.personal?.country || form.personal?.country || 'India'
    },
    contact: {
      ...form.contact,
      email: p.contact?.email || p.email || form.contact?.email,
      phone: p.contact?.phone || p.phone || form.contact?.phone,
      linkedin: p.contact?.linkedin || form.contact?.linkedin,
      website: p.contact?.website || form.contact?.website
    },
    educational: p.educational?.length ? p.educational : form.educational,
    professional: p.professional?.length ? p.professional : form.professional,
    languagesKnown: p.languagesKnown?.length ? p.languagesKnown : form.languagesKnown || [],
    isFresher: p.isFresher ?? form.isFresher,
    preferredWorkingModes: p.preferredWorkingModes?.length
      ? p.preferredWorkingModes
      : form.preferredWorkingModes,
    contactChannels: p.contactChannels?.length ? p.contactChannels : form.contactChannels
  };
}

export function parsedResumeSummary(parsed) {
  const filled = [
    parsed.name && 'name',
    parsed.email && 'email',
    parsed.phone && 'phone',
    parsed.personal?.dob && 'date of birth',
    parsed.personal?.gender && 'gender',
    parsed.personal?.maritalStatus && 'marital status',
    parsed.personal?.address && 'address',
    parsed.languagesKnown?.length && `${parsed.languagesKnown.length} languages`,
    parsed.skills?.length && `${parsed.skills.length} skills`,
    parsed.educational?.length && `${parsed.educational.length} education`,
    parsed.professional?.length && `${parsed.professional.length} experience`
  ].filter(Boolean);
  return filled.length
    ? `Resume parsed. Filled: ${filled.join(', ')}. Review fields below.`
    : 'Resume parsed with limited matches. Review and complete fields below.';
}
